import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'pm-form-field-radio',
  imports: [RadioButtonModule, CommonModule, ReactiveFormsModule],
  templateUrl: './pm-form-field-radio.component.html',
  styleUrl: './pm-form-field-radio.component.scss',
})
export class PmFormFieldRadioComponent extends FormFieldComponent {}
